import { render, staticRenderFns } from "./safety_monitoring.vue?vue&type=template&id=bdcc5458&scoped=true&"
import script from "./safety_monitoring.vue?vue&type=script&lang=js&"
export * from "./safety_monitoring.vue?vue&type=script&lang=js&"
import style0 from "./safety_monitoring.vue?vue&type=style&index=0&id=bdcc5458&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc5458",
  null
  
)

export default component.exports